import styled from 'styled-components'

interface ISingleFileViewerUploadEmptyStateStyledProps {}

export const SingleFileViewerUploadEmptyStateStyled = styled.div<ISingleFileViewerUploadEmptyStateStyledProps>`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`
